import UPButton from 'components/button';
import { useTranslation } from 'react-i18next';
import { CONTRACTS__CANCEL, GENERAL__CLOSE, GENERAL__CONFIRM, GENERAL__SAVE_BUTTON } from 'translations/constants';
import { FooterContainer } from '../styles';

interface PanelFooterProps {
  onSave: () => void;
  onClose: () => void;
  isSaving: boolean;
  mode?: 'save' | 'confirm' | 'readOnly';
}

const PanelFooter = (props: PanelFooterProps) => {
  const { onSave, onClose, isSaving, mode = 'save' } = props;
  const { t } = useTranslation();

  if (mode === 'readOnly') {
    return (
      <FooterContainer>
        <UPButton text={t(GENERAL__CLOSE)} onClick={onClose} outlined id="detail-panel-close-button" />
      </FooterContainer>
    );
  }

  return (
    <FooterContainer>
      <UPButton
        text={mode === 'confirm' ? t(GENERAL__CONFIRM) : t(GENERAL__SAVE_BUTTON)}
        onClick={onSave}
        disabled={isSaving}
        id="detail-panel-save-button"
      />
      <UPButton text={t(CONTRACTS__CANCEL)} onClick={onClose} outlined id="detail-panel-close-button" />
    </FooterContainer>
  );
};

PanelFooter.defaultProps = {
  mode: 'save',
};

export default PanelFooter;
